/**
 * How a verification code went (the server's `channel`): codes go on WhatsApp first, where an SMS
 * to a UAE number can take minutes, and by text when WhatsApp cannot take them. Every code step
 * says which, and offers "Text me instead" — re-sending with `channel: 'sms'` — when it went on
 * WhatsApp (the number may not be on WhatsApp at all).
 */
export type CodeChannel = 'whatsapp' | 'sms';

export function codeSentBy(channel: string | null | undefined): string {
    return channel === 'whatsapp' ? 'on WhatsApp' : 'by text';
}

export function offersTextInstead(channel: string | null | undefined): boolean {
    return channel === 'whatsapp';
}
